/** Тексты пространства «more». Ключи именуются по смыслу, а не по месту. */
export const more = {
  title: 'Ещё',

  section: {
    account: 'Аккаунт',
    links: 'Разделы',
  },

  account: {
    guest: 'Гость',
    readOnly: 'только чтение',
    vkId: 'id {{id}}',
  },

  nav: {
    profile: {
      title: 'Профиль',
      hint: 'Скрыть ссылку на профиль в реестре и посмотреть свои данные',
    },
    rules: {
      title: 'Правила заполнения анкеты',
      hint: 'Что запрещено в анкете и сколько способностей можно взять на старте',
    },
    admin: {
      title: 'Админка',
      hint: 'Участники, персонажи, настройки системы и журнал действий',
    },
    dataDeletion: {
      title: 'Удалить мои данные',
      hint: 'Что именно хранится и как это удалить',
    },
  },

  about:
    '«MESAHIST» — приложение ролевого проекта. Реестр и база внешек открыты всем, кто открыл приложение; заводить персонажа и вести склад может только тот, кого администрация добавила в список участников.',

  /* ── Правила анкеты ─────────────────────────────────────────────────── */
  rules: {
    title: 'Правила анкеты',

    intro: {
      title: 'Прочитайте до отправки',
      text: 'Это короткая выжимка. Модератор проверяет анкету по тем же пунктам, что перечислены ниже, — если что-то из этого в анкете есть, заявку вернут с комментарием, и ждать решения придётся заново.',
    },

    race: {
      title: 'Расы, которые нельзя брать',
      hint: 'Поле «Раса» заполняется свободным текстом, поэтому автоматической проверки нет: запрет смотрит модератор. Переименование не помогает — важна суть, а не слово. Всё остальное обсуждаемо: если сомневаетесь, спросите администрацию до отправки.',
      forbidden: {
        gods: 'боги',
        demigods: 'полубоги',
        angels: 'ангелы',
        demons: 'демоны',
        elves: 'эльфы',
        fairies: 'феи',
        fey: 'фейри',
        dragons: 'драконы',
        centaurs: 'кентавры',
        lynxWerewolves: 'оборотни-рыси',
      },
    },

    ability: {
      limit: {
        title: 'Не больше двух на старте',
        text: 'В анкете можно заявить максимум две особые способности. Остальные добываются в игре: квест-мастер подтверждает их отдельно, и они появляются в карточке персонажа сами.',
      },
      forbiddenSchools: {
        title: 'Некромагия, вуду и худу запрещены',
        text: 'Эти направления не берутся ни на старте, ни через квесты — ни под другими названиями.',
      },
      description: {
        title: 'Описание важнее названия',
        text: '«Управляет огнём» без рамок и цены модератор вернёт. Напишите, что способность умеет, чего не умеет и чем даётся персонажу.',
      },
    },

    review: {
      title: 'Как проходит проверка',
      dorm: {
        title: 'Общежитие назначает модератор',
        text: 'В анкете этого поля нет: общежитие и класс — админские поля. Принять анкету без общежития нельзя, поэтому оно появится вместе с решением.',
      },
      edit: {
        title: 'Заявку можно править, пока она на проверке',
        text: 'Правка не создаёт новую заявку, но отправляет её в конец очереди — сроки сдвигаются.',
      },
      comment: {
        title: 'Отказ всегда с комментарием',
        text: 'Модератор обязан написать причину. Она придёт в раздел «Мой персонаж», по ней и правьте.',
      },
      registry: {
        title: 'В реестре видна только принятая версия',
        text: 'Черновик и заявку на проверке не видит никто, кроме вас и модераторов.',
      },
    },

    doubts: {
      title: 'Остались сомнения',
      text: 'Спросить до отправки дешевле, чем ждать очередь и получить отказ. Напишите администрации проекта в сообщения сообщества.',
    },
  },
} as const;
